$(window).on('load',function () {
    
});
